import { gql } from '@apollo/client';

export const GET_ALL_TMS_DRIVERS = gql`
    query GetAllTmsDrivers {
        getAllTmsDrivers {
            id
            accountId
            vehicleId
            carrierId
            driverName
            status
        }
    }
`;

export const GET_TMS_DRIVERS_BY_WAREHOUSE_ID = gql`
    query GetTmsDriversByWarehouseId($warehouseId: Long!, $routeType: Int) {
        getTmsDriversByWarehouseId(warehouseId: $warehouseId, routeType: $routeType) {
            id
            accountId
            vehicleId
            carrierId
            driverName
            status
        }
    }
`;

export interface TmsDriverType {
    id: string;
    accountId: number;
    vehicleId?: number;
    carrierId: number;
    driverName: string;
    status?: number;
}

export interface GetAllTmsDriversResponse {
    getAllTmsDrivers: TmsDriverType[];
}

export interface GetTmsDriversByWarehouseIdVariables {
    warehouseId: number;
    routeType?: number;
}

export interface GetTmsDriversByWarehouseIdResponse {
    getTmsDriversByWarehouseId: TmsDriverType[];
}

